import { Route, Switch, useRouteMatch } from "react-router-dom";
import { AllProjects } from "./AllProjects";
import { Project } from "./Project";

export const Projects = () => {
  let { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/`} component={AllProjects} />
      <Route exact path={`${path}/:projectId`} component={Project} />
    </Switch>
  );
};
